import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1489c26d&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "@/views/master/_apiPanel.css?vue&type=style&index=0&id=1489c26d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1489c26d",
  null
  
)

export default component.exports